import { render, staticRenderFns } from "./FaxMetadata.vue?vue&type=template&id=93763d4e&"
import script from "./FaxMetadata.vue?vue&type=script&lang=js&"
export * from "./FaxMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93763d4e')) {
      api.createRecord('93763d4e', component.options)
    } else {
      api.reload('93763d4e', component.options)
    }
    module.hot.accept("./FaxMetadata.vue?vue&type=template&id=93763d4e&", function () {
      api.rerender('93763d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Information/Metadata/FaxMetadata.vue"
export default component.exports